import request from "@/utils/request";

export const getAnnualList = () => {
  return request.get("v1/cap/imsbs/annuals");
};
